
(function(){
  'use strict';
  // menu mobile
  var header=document.querySelector('.site-header');
  var burger=document.querySelector('.burger');
  if(burger&&header){burger.addEventListener('click',function(){header.classList.toggle('mopen');});
    document.querySelectorAll('.nav-left a').forEach(function(a){a.addEventListener('click',function(){header.classList.remove('mopen');});});}

  // onglets de collection
  document.querySelectorAll('[data-tabs]').forEach(function(scope){
    var tabs=scope.querySelectorAll('.tab');
    tabs.forEach(function(t){t.addEventListener('click',function(){
      scope.querySelectorAll('.tab').forEach(function(x){x.classList.remove('on');});
      scope.querySelectorAll('.panel').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var p=scope.querySelector('#'+t.getAttribute('data-t'));
      if(p)p.classList.add('on');
    });});
  });

  // compte a rebours
  document.querySelectorAll('[data-countdown]').forEach(function(el){
    var end=new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(end)){end=Date.now()+3*864e5;}
    var d=el.querySelector('.cd-d'),h=el.querySelector('.cd-h'),m=el.querySelector('.cd-m'),s=el.querySelector('.cd-s');
    function pad(n){return(n<10?'0':'')+n;}
    function tick(){var diff=end-Date.now();if(diff<0)diff=0;
      if(d)d.textContent=pad(Math.floor(diff/864e5));
      if(h)h.textContent=pad(Math.floor(diff%864e5/36e5));
      if(m)m.textContent=pad(Math.floor(diff%36e5/6e4));
      if(s)s.textContent=pad(Math.floor(diff%6e4/1e3));}
    tick();setInterval(tick,1000);
  });

  // galerie produit : miniatures
  document.querySelectorAll('[data-gallery]').forEach(function(g){
    var main=g.querySelector('[data-main] img');
    g.querySelectorAll('.thumbs img').forEach(function(t){
      t.addEventListener('click',function(){if(main)main.src=t.getAttribute('data-full')||t.src;});
    });
  });

  // reveal au scroll
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('in');io.unobserve(en.target);}});},{threshold:.1});
    document.querySelectorAll('.rv').forEach(function(el){io.observe(el);});
  } else {document.querySelectorAll('.rv').forEach(function(el){el.classList.add('in');});}
})();

(function(){
  'use strict';
  // formulaire produit : tailles -> variante
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var raw=form.querySelector('[data-variants]');if(!raw)return;
    var variants=JSON.parse(raw.textContent);
    var idInput=form.querySelector('input[name="id"]');
    var btn=form.querySelector('[data-add]');
    var priceEl=document.querySelector('[data-price]');
    var fmt=form.getAttribute('data-money')||'{{amount}} €';
    function money(c){var n=(c/100).toFixed(2);var fr=n.replace('.',',');
      if(fmt.indexOf('amount_no_decimals')>-1)return fmt.replace(/\{\{.*?\}\}/,String(Math.round(c/100)));
      if(fmt.indexOf('comma')>-1)return fmt.replace(/\{\{.*?\}\}/,fr);
      return fmt.replace(/\{\{.*?\}\}/,n);}
    function sel(){var out=[];form.querySelectorAll('.opt').forEach(function(o,i){var c=o.querySelector('input:checked');out[i]=c?c.value:null;});return out;}
    function update(){
      var s=sel();
      var v=variants.filter(function(x){return s.every(function(val,i){return val===null||x.options[i]===val;});})[0];
      form.querySelectorAll('.size').forEach(function(l){l.classList.toggle('on',l.querySelector('input').checked);});
      if(!v){if(btn){btn.disabled=true;btn.textContent='Indisponible';}return;}
      if(idInput)idInput.value=v.id;
      if(priceEl)priceEl.innerHTML=(v.compare_at_price&&v.compare_at_price>v.price?'<s>'+money(v.compare_at_price)+'</s> <span class="sale">'+money(v.price)+'</span>':money(v.price));
      if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Ajouter au panier':'Épuisé';}
    }
    form.addEventListener('change',function(e){if(e.target.matches('.opt input'))update();});
    update();
  });
  // quantité
  document.querySelectorAll('.qty').forEach(function(q){
    var i=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
      var v=parseInt(i.value||'1',10);v+=b.getAttribute('data-qty')==='+'?1:-1;if(v<1)v=1;i.value=v;});});
  });
})();
